import { toast } from "react-toastify";
import { fetchStationUsageSuccess, fetchStationUsageFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { GET_STATION_USAGE_API } from "../../constants/constants";

export const getAllStationUsage =
  (setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    await determineBaseUrlAndPerformApiCall(
      `${GET_STATION_USAGE_API}?unit=Wh&count=10&period=${
        dateRange?.period || "3m"
      }${
        dateRange?.period === "custom"
          ? `&from=${dateRange?.from}&to=${dateRange?.to}`
          : ""
      }`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          dispatch(fetchStationUsageSuccess(response || []));
          // dispatch(setSuccessMessage(true));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchStationUsageSuccess([]));
          } else {
            dispatch(fetchStationUsageFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };
